import React from "react";
import ReactDOM from "react-dom";
import { FiAlertTriangle, FiX } from "react-icons/fi";
import { DialogOverlay, DialogContainer, DialogHeader, DialogBody, DialogFooter, DialogButton } from "./styles";

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirmar ação",
  message = "Tem certeza que deseja continuar?",
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  type = "danger", // danger, warning, info
  children // conteúdo extra opcional (ex.: checkbox de opção)
}) {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  // Portal direto no body: telas cujos containers raiz usam regras como
  // `> * { position: relative }` ou `overflow: hidden` (ex.: email
  // marketing) quebrariam o `position: fixed` do overlay, fazendo o modal
  // renderizar em fluxo no fim da página em vez de flutuar.
  return ReactDOM.createPortal(
    <DialogOverlay onClick={onClose}>
      <DialogContainer onClick={(e) => e.stopPropagation()} $type={type}>
        <DialogHeader>
          <div className="header-content">
            <FiAlertTriangle className="icon" />
            <h3>{title}</h3>
          </div>
          <button className="close-btn" onClick={onClose}>
            <FiX />
          </button>
        </DialogHeader>
        
        <DialogBody>
          <p>{message}</p>
          {children}
        </DialogBody>
        
        <DialogFooter>
          <DialogButton $variant="secondary" onClick={onClose}>
            {cancelText}
          </DialogButton>
          <DialogButton $variant={type} onClick={handleConfirm}>
            {confirmText}
          </DialogButton>
        </DialogFooter>
      </DialogContainer>
    </DialogOverlay>,
    document.body
  );
}
